import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Battery } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("demo@bin.io");
  const [password, setPassword] = useState("bin12345");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Authenticated. Routing to console.");
      navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#050505]">
      <div className="hidden lg:flex flex-col justify-between border-r border-zinc-900 p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20"
             style={{
               backgroundImage: "linear-gradient(rgba(0,229,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,255,0.15) 1px, transparent 1px)",
               backgroundSize: "80px 80px",
             }}
        />
        <div className="relative flex items-center gap-2">
          <div className="w-7 h-7 border border-cyan-400 grid place-items-center">
            <Battery className="w-3.5 h-3.5 text-cyan-400" />
          </div>
          <div>
            <div className="font-black text-lg leading-none tracking-tighter">BIN</div>
            <div className="bin-label">Battery Internet Network</div>
          </div>
        </div>
        <div className="relative">
          <div className="bin-label mb-3">/ AUTH PORTAL</div>
          <h2 className="text-5xl font-black tracking-tighter">
            Identify.<br />
            <span className="text-cyan-400">Authorize.</span><br />
            Energize.
          </h2>
          <p className="mt-6 text-sm text-zinc-500 max-w-md">
            Energy access begins with identity. Sign in to access your console.
          </p>
        </div>
        <div className="relative font-mono text-xs text-zinc-600">CONSOLE-EAST-1 · v0.1</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="bin-label mb-3">SIGN IN</div>
          <h1 className="text-3xl font-black tracking-tighter mb-8">Enter the network</h1>

          <label className="bin-label">Email</label>
          <input
            data-testid="login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
            className="w-full mt-2 mb-5 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400"
          />

          <label className="bin-label">Password</label>
          <input
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
            className="w-full mt-2 mb-6 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400"
          />

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bin-btn bin-btn-primary"
          >
            {loading ? "Connecting…" : "Authenticate"}
          </button>

          <div className="mt-6 text-xs text-zinc-500">
            No account? <Link to="/register" className="text-cyan-400 hover:underline">Register</Link>
          </div>

          <div className="mt-8 p-3 bin-card-elevated">
            <div className="bin-label mb-2">DEMO ACCOUNTS</div>
            <div className="text-xs font-mono text-zinc-400 space-y-1">
              <div>demo@bin.io · all roles</div>
              <div>alex.consumer@bin.io · consumer</div>
              <div>ops@bin.io · operator</div>
              <div>safety@bin.io · public-safety</div>
              <div className="pt-1 text-zinc-600">password · bin12345</div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
